import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsService, IntercomService } from './core/analytics';
import { AuthService } from './core/auth/auth.service';
import { DevThemeToggle } from './core/theming';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DevThemeToggle],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  // The theme toggle sits OUTSIDE the outlet so it survives every route. It
  // renders nothing on production builds.
  template: `<router-outlet />
    <ce-dev-theme-toggle />`,
})
export class App {
  // Boot Intercom so the support launcher is available on the (unauthenticated)
  // auth-gateway screens — sign-in, register, forgot/reset password. The
  // service existed but was never booted, so the widget never loaded. (CLUB-1930)
  constructor() {
    inject(IntercomService).boot();

    // GA4, production only; a no-op everywhere else.
    const analytics = inject(AnalyticsService);
    const auth = inject(AuthService);
    analytics.start();
    effect(() => analytics.setUserId(auth.user()?.uid ?? null));
  }
}
